import { render, staticRenderFns } from "./CmgSustainabilityStatsPageLink.vue?vue&type=template&id=c1a99902&scoped=true&lang=pug&"
import script from "./cmg-sustainability-stats-page-link.ts?vue&type=script&lang=ts&"
export * from "./cmg-sustainability-stats-page-link.ts?vue&type=script&lang=ts&"
import style0 from "./CmgSustainabilityStatsPageLink.vue?vue&type=style&index=0&id=c1a99902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a99902",
  null
  
)

export default component.exports